module.exports = __webpack_public_path__ + "img/properties-dashboard.7b1b3db0.jpg";